function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { FontFamilyBrands, typographyDefaultValues } from './constants';
export var themeTypography = function themeTypography() {
  var typographyOverrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var themedTypography = _objectSpread({}, typographyDefaultValues);

  Object.keys(typographyOverrides).forEach(function (typographyName) {
    // Users can also pass in a supported Brand name (like "DoorDash" or "Caviar")
    // and this block will map it to the correct font family
    if (typographyName === 'FontFamily' && FontFamilyBrands[typographyOverrides[typographyName]]) {
      themedTypography[typographyName] = FontFamilyBrands[typographyOverrides[typographyName]];
    } else {
      themedTypography[typographyName] = typographyOverrides[typographyName];
    }
  });
  return themedTypography;
};